<template>
  <section class="reviews-section">
    <h2 class="text-center">What Our Customers Say About Us</h2>
    
    <div class="reviews-container">
      <!-- Review 1 -->
      <div class="review-card">
        <div class="stars">★★★★★</div>
        <p class="review-text">
          "Very professional. Great workmanship. Good communication. Fair price when compared to other companies. Will do business again. These are now my go-to people."
        </p>
        <h4 class="reviewer">— Pastor F.</h4>
      </div>

      <!-- Review 2 -->
      <div class="review-card">
        <div class="stars">★★★★★</div>
        <p class="review-text">
          "Harold was very professional and courteous. He responded promptly to the request, performed the work accurately at a reasonable cost and did an excellent clean-up afterwards. I would definitely hire him again."
        </p>
        <h4 class="reviewer">— Charles S.</h4>
      </div>

      <!-- Review 3 -->
      <div class="review-card">
        <div class="stars">★★★★★</div>
        <p class="review-text">
We had a break  in our drain line and the workers did a fantastic job. From the beginning it was professional, with knowledgeable workers who did everything they could to give the best quality products and service. They did everything They could to get the job done. Harold answered every question and kept us up on the progress. He went over and beyond.  </p>
        <h4 class="reviewer">— Carlos Mejia</h4>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CustomerReviews",
};
</script>

<style scoped>
/* Section Styling */
.reviews-section {
  text-align: center;
  padding: 50px 20px;
  background: #f8fafc;
  color: #1e293b;
}

/* Reviews Container */
.reviews-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
}

/* Individual Review Card */
.review-card {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 320px;
  text-align: center;
}

/* Five-Star Rating */
.stars {
  font-size: 24px;
  color: #facc15; /* Gold */
  margin-bottom: 10px;
}

/* Review Text */
.review-text {
  font-size: 16px;
  font-style: italic;
  color: #475569;
  margin-bottom: 15px;
}

/* Reviewer Name */
.reviewer {
  font-size: 18px;
  font-weight: bold;
  color: #334155;
}
</style>
